import React, {  useState,useRef, useEffect } from 'react';
import axios from 'axios';
import Modal from '../Modal';
import Locations from './CVLocations';
import { getUserId,aPIURL,auTHURL,getUser } from '../../utils/common';
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
//import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Switch from "react-switch";
import Enumerate from "linq";
import { validationLatitudeLongitude } from "validation-latitude-longitude";


const AlertSettings = () => 
{
    const fileType ="xlsx";
    const [SNo,setSNo]=useState("");
    let [advPriority, setAdvPriority] = useState("");
    let [advAlertType, setAdvAlertType] = useState("");

    const tableRef = useRef(null);
    const API_URL=aPIURL();
    const AUTH_URL= auTHURL();
    const [userId, setUserId]  = useState({});
    const [custID, setCustID]  = useState('0');
    const [dIMEINo, setDIMEINo]  = useState('0'); 
    const [devName, setDevName]  = useState(""); 
    const [dID, setDID]  = useState(0);
    const [vCategoryID, setVCategoryID]  = useState('0');
    const [ignitionType ,setIgnitionType] = useState(1);

    const [post, setPost] = useState([]);
    const [temppost, setTempPost] = useState([]);
    const [searchpost, setSearchempPost] = useState([]);

    const [deviceData , setDeviceData]  =useState([]);
    const [vCategoryData,setVCategoryData ]  =useState([]);
    const [showDetails,setShowDetails ]  = useState(false);
    const [showAlertSettingDetails,setShowAlertSettingDetails ]  = useState(false);
    const [showEditAlertSettingDetails,setShowEditAlertSettingDetails ]  = useState(false);
    const [vehicleNo,setVehicleNo]=useState(0);
    const [alertId, setAlertId]=useState(0);
    const [alertTypeId, setAlertTypeId]=useState(0);
    const [vehicleData,setVehicleData] =useState([]);
    const [order, setOrder] = useState("ASC");
    const [number, setNumber] = useState(1); // No of pages
    const [postPerPage] = useState(10);
    const AccountID =getUserId(); 
    const UserName=getUser();
    let [temperatureValue,setTemperatureValue]=useState(0);
    const[distanceValue,setDistanceValue]=useState(0);
    const [alertData,setAlertData] =useState([]);
    
    const [maintenanceStatusDisplay,setMaintenanceStatusDisplay]  = useState('none');
    const [unauthorizedUsageDisplay,setUnauthorizedUsageDisplay] = useState('none'); 
    const [geoFenceDisplay,setGeoFenceDisplay] = useState('none');
    const [speedingDisplay,setSpeedingDisplay] = useState('none');
    const [landMarkDisplay,setLandmarkDisplay] = useState('none');
    const [parkingDisplay,setParkingDisplay] = useState('none');    
    const [ignitionOnDisplay,setIgnitionOnDisplay] = useState('none');
    const [excessIdleDisplay,setExcessIdleDisplay] = useState('none');
    const [longStopDisplay,setLongStopDisplay] = useState('none');
    const [lateStartDisplay,setLateStartDisplay] = useState('none');
    //const [highTemperatureDisplay,setHighTemperatureDisplay]  = useState('none');
    //const [lowTemperatureDisplay,setLowTemperatureDisplay]  = useState('none');
    const [thresholdValueDisplay,setThresholdValueDisplay] = useState('none');
    const [expiredDeviceDisplay,setExpiredDeviceDisplay] = useState('none');
    const [kilometerDisplay,setKilometerDisplay]= useState('none');
    const [inputs, setInputs] = useState({});
    
    const [alertType, setAlertType]=useState("N/A");
    const [duration,setDuration] = useState(0);
    const [maintenanceDate,setMaintenanceDate]=useState("0");
    const [ignitionStatus,setIgnitionStatus]=useState("0");
    const [expiryDate, setExpiryDate]= useState("0");
    const [latitude, setLatitude] = useState("0");
    const [longitude, setLongitude] = useState("0");
    const [maxmSpeed, setMaxmSpeed]= useState(0);
    const [timeFrom, setTimeFrom]= useState("0");
    const [timeTo, setTimeTo]= useState("0");
    const [inputsEdit, setInputsEdit] = useState({});
    const [switchValue, setSwitchValue]= useState(true);
    const [expirationDateD,setExpirationDateD] =useState([]);
    const [statusId, setStatusId]= useState(0);
    let [arrayPriority, setarrayPriority] = useState([]);
    let [arrayAlertType, setarrayAlertType] = useState([]);
    
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
    var yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd
    }
    if (mm < 10) {
        mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd;

  const sorting=(col)=>
  {
    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }  
            
  }


  useEffect(() => 
  {    
            FillGridInitial(statusId);    
  }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);
 
 
const FillGrid=(Type_ID)=>
{
    
    const url=API_URL+`AlertSettings?AccountID=${AccountID}&Type_ID=${Type_ID}`;                          
   
    setPost([]);    
    
    axios.post(url).then(response => 
      {  
           setPost(response.data.data);
           console.log(response.data.data);
               
      }).catch(function(error) 
      {
            console.log(error.message);
      
      });
      
}  


const FillGridInitial=(Type_ID)=>
  {
      
      const url=API_URL+`AlertSettings?AccountID=${AccountID}&Type_ID=${Type_ID}`;       
      setPost([]);
     
      axios.post(url).then(response => 
        {  
           setPost(response.data.data);
           //console.log("===============================uniquelist==================================================");      
           //console.log(response.data.data); 
            let ids = {};
              response.data.data.forEach(obj => 
                {
                  if (!ids[obj.priorities]) 
                    {
                      ids[obj.priorities] = true;
                      arrayPriority.push(obj);
                  }
              });
           let ids2 = {};
              response.data.data.forEach(obj => 
                {
                  if (!ids[obj.alertType]) 
                    {
                      ids[obj.alertType] = true;
                      arrayAlertType.push(obj);
                  }
              });
              
        
        }).catch(function(error) 
        {
              console.log(error.message);
        
        });
  }  
  
  
const changeHandler = (e) => 
{   
    setSNo(e.target.value)
} 
const ChangeSourceAddress = (e) => 
{
  if(e.target.value=='Select Priority Type')
    {setAdvPriority("");
    }
    else{setAdvPriority(e.target.value);}
  
}
const ChangeEndAddress = (e) => 
{
  if(e.target.value=='Select Alert Type')
  {setAdvAlertType("");}else{setAdvAlertType(e.target.value);}
}
const ResetTripList=()=>
{
  setAdvPriority("");
  setAdvAlertType("");
  setSNo("");
  const url=API_URL+`AlertSettings?AccountID=${AccountID}&Type_ID=0`;                          
      setPost([]);     
    axios.post(url).then(response => 
      {             
         setPost(response.data.data);        
      }).catch(function(error) 
      {
            console.log(error.message);      
      });  
}

const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
        
  };
     
 
  const FilterGrid =() => 
    {
        
      const Account_ID = getUserId(); 
      const searchparams = JSON.stringify({
        "accountid": Account_ID,
        "VehicleNumber":SNo.trim(),
        "PeriorityType":advPriority,
        "AlertType": advAlertType,
        "OrderBy": ""
      });
  
    // alert(API_URL+'GpsSearchAlertSettingAdvance/');
     //alert(searchparams)
     setPost([]);
     
      axios.post(API_URL+'GpsSearchAlertSettingAdvance/', searchparams,
      {  
            "headers":{"content-type": "application/json",},})
     .then(function (response) 
     {    
          setPost(response.data.data);      
          //console.log(response.data.data);
     })
     .catch(function (error) 
     {
           toast.info("No data found !");
     });
  
    }
const NewAlertSettingModal = () => 
{      
       setInputs({});
       setDID(0);
       setAlertTypeId(0);
       setShowDetails(true); 
       const vurls=API_URL+`VehicleList/?AccountID=${AccountID}&TypeID=0`;    //Bind Drop Down for vehicle List
       
        axios.get(vurls).then(response =>
             {                  
                    const updatedList =  response.data.data.filter((curElem) => {                    
                    return curElem.status === "Enabled";
              });   
                   setVehicleData(updatedList);                    

             }).catch(function(error) 
             {  
                  console.log(error.message); 
             });

            //setAlertData
            const Alurl = API_URL+`GetAlertTypes/?AccountID=0`;       //Bind Drop Down for Alert Types list  
            setAlertData([]); 
            axios.post(Alurl).then(response => 
            {  
                //console.log(response.data.data);        
                setAlertData(response.data.data)   
           
      }).catch(function(error) { console.log(error.message);  });                         
            
}


const closeModal = () => 
{
      setShowDetails(false); 
      setShowAlertSettingDetails(false);                  
      setShowEditAlertSettingDetails(false);   
      FillGrid(statusId);   
      setMaintenanceStatusDisplay('none');
      setUnauthorizedUsageDisplay('none');
      setGeoFenceDisplay('none');
      setSpeedingDisplay('none');
      setLandmarkDisplay('none');
      setParkingDisplay('none');
      setIgnitionOnDisplay('none');
      setExcessIdleDisplay('none');
      setLongStopDisplay('none');
      setLateStartDisplay('none');
      setExpiredDeviceDisplay('none');   
      setThresholdValueDisplay('none'); 

       
}
const closeAlertSettingModal = () => 
  {
      setShowDetails(false); 
      setShowAlertSettingDetails(false);                  
      setShowEditAlertSettingDetails(false);   
      FillGrid(statusId); 
  }
const exportStatus = e => {
 
  setStatusId(e.target.value);
  const value = e.target.value; 
  FillGrid(e.target.value);
}
const exportToCSV=()=>
  {
    const newPost = post.map(({ accountID,deviceID,id, ...rest }) => rest);
     const ws= XLSX.utils.json_to_sheet(newPost);        
     var wscols = [
        {wch:5} ,
        {wch:20},
        {wch:20},
        {wch:15},
        {wch:15},
        {wch:60},
        {wch:20},         
        {wch:20}
    ];
 
    var wsrows = [
       {hpx: 30}
    ];
    
    ws['!cols'] = wscols;
    ws['!rows']=wsrows;
         
    let Heading = [['S.No.','Vehicle Number','Alert Type','Status','Priorities','Description','Created ON','Created By']];
    const wb={Sheets:{Alerts:ws},SheetNames:["Alerts"]};
    XLSX.utils.sheet_add_aoa(ws, Heading);     
    const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
    const data= new Blob([excelBuffer],{type:fileType});
    FileSaver.saveAs(data,"AvtAlertsReport"+".xlsx");
   }
const exportDownload = e => 
{  
  
  const value = e.target.value; 
  
  if(value=="Excel")
  {
        exportToCSV();   
       //onDownload();
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}

/*const { onDownload } = useDownloadExcel({
  currentTableRef: tableRef.current,
  filename: "Alert Details",
  sheet: "Alert Settings"
});*/

const ChangeVehicleNo = (e) => {
         
         setVehicleNo(e.target.selectedOptions[0].text);
         setDID(e.target.value);
        
         //device expiry date
         const devurls=API_URL+`GetDeviceDetails/${e.target.value}`;    
         //alert(devurls);
         axios.post(devurls).then(response =>
              {       
                        //setExpiryDate(response.data.data[0].expirationDate); 
                        //console.log(response.data.data[0].expirationDate);   
                        inputs.expirydate =  response.data.data[0].expirationDate; 
                        //console.log("----------------------------response.data.data[0].expirationDate---------------------------------------------");                                                          
                                  
              }).catch(function(error) 
              {  
                   console.log(error.message); 
              });
               
               
}
const ShowHideControls=(Alert_TyprId)=>
  {

           setThresholdValueDisplay('block');

           //alert(Alert_TyprId);
           if(Alert_TyprId == 1 ||Alert_TyprId == 13 ||Alert_TyprId == 14||Alert_TyprId == 15||Alert_TyprId == 16||Alert_TyprId == 17||Alert_TyprId == 18 )//Maintenance Status Alert
            {
              
                   setMaintenanceStatusDisplay('block');
                   setUnauthorizedUsageDisplay('none');
                   setGeoFenceDisplay('none');
                   setSpeedingDisplay('none');
                   setLandmarkDisplay('none');
                   setParkingDisplay('none');
                   setIgnitionOnDisplay('none');
                   setExcessIdleDisplay('none');
                   setLongStopDisplay('none');
                   setLateStartDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                   setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 2)//Unauthorized Usage Alert
            {
                   setUnauthorizedUsageDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setGeoFenceDisplay('none');
                   setSpeedingDisplay('none');
                   setLandmarkDisplay('none');
                   setParkingDisplay('none');
                   setIgnitionOnDisplay('none');
                   setExcessIdleDisplay('none');
                   setLongStopDisplay('none');
                   setLateStartDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                   setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 3)//Geo-fence Alert
            {
                   setGeoFenceDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setUnauthorizedUsageDisplay('none');
                   setSpeedingDisplay('none');
                   setLandmarkDisplay('none');
                   setParkingDisplay('none');
                   setIgnitionOnDisplay('none');
                   setExcessIdleDisplay('none');
                   setLongStopDisplay('none');
                   setLateStartDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                   setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 4)//Speeding Alert
            {
                   setSpeedingDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setUnauthorizedUsageDisplay('none');
                   setGeoFenceDisplay('none');
                   setLandmarkDisplay('none');
                   setParkingDisplay('none');
                   setIgnitionOnDisplay('none');
                   setExcessIdleDisplay('none');
                   setLongStopDisplay('none');
                   setLateStartDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                   setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 5)//Enter Landmark Alert
            {
                   setLandmarkDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setUnauthorizedUsageDisplay('none');
                   setGeoFenceDisplay('none');
                   setSpeedingDisplay('none');
                   setIgnitionOnDisplay('none');
                   setExcessIdleDisplay('none');
                   setLongStopDisplay('none');
                   setLateStartDisplay('none');
                   setParkingDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                   setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 6)//Ignition On Alert
            {
                   setIgnitionOnDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setUnauthorizedUsageDisplay('none');
                   setGeoFenceDisplay('none');
                   setSpeedingDisplay('none');
                   setLandmarkDisplay('none'); 
                   setParkingDisplay('none');                  
                   setExcessIdleDisplay('none');
                   setLongStopDisplay('none');
                   setLateStartDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                   setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 7)//Excess Idle Alert
            {
                   
                   setExcessIdleDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setUnauthorizedUsageDisplay('none');
                   setGeoFenceDisplay('none');
                   setSpeedingDisplay('none');
                   setLandmarkDisplay('none');
                   setParkingDisplay('none');
                   setIgnitionOnDisplay('none');                   
                   setLongStopDisplay('none');
                   setLateStartDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                   setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 8)//Long Stop Alert
            {
                   
                   setLongStopDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setUnauthorizedUsageDisplay('none');
                   setGeoFenceDisplay('none');
                   setSpeedingDisplay('none');
                   setLandmarkDisplay('none');
                   setParkingDisplay('none');
                   setIgnitionOnDisplay('none');
                   setExcessIdleDisplay('none');                   
                   setLateStartDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                    setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 9)//Late Start Alert
            {
                   
                   setLateStartDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setUnauthorizedUsageDisplay('none');
                   setGeoFenceDisplay('none');
                   setSpeedingDisplay('none');
                   setLandmarkDisplay('none');
                   setParkingDisplay('none');
                   setIgnitionOnDisplay('none');
                   setExcessIdleDisplay('none');
                   setLongStopDisplay('none');                   
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   setExpiredDeviceDisplay('none');
                    setKilometerDisplay('none');
            }
       
            else if(Alert_TyprId == 10)//Expired Device
            {
                  
                   setExpiredDeviceDisplay('block');
                   setMaintenanceStatusDisplay('none');
                   setUnauthorizedUsageDisplay('none');
                   setGeoFenceDisplay('none');
                   setSpeedingDisplay('none');
                   setLandmarkDisplay('none');
                   setParkingDisplay('none');
                   setIgnitionOnDisplay('none');
                   setExcessIdleDisplay('none');
                   setLongStopDisplay('none');
                   setLateStartDisplay('none');
                    setKilometerDisplay('none');
                   //setHighTemperatureDisplay('none');
                   //setLowTemperatureDisplay('none');
                   
            }
            else if(Alert_TyprId == 11)//Ignition OFF Alert
              {
                     setIgnitionOnDisplay('block');
                     setMaintenanceStatusDisplay('none');
                     setUnauthorizedUsageDisplay('none');
                     setGeoFenceDisplay('none');
                     setSpeedingDisplay('none');
                     setLandmarkDisplay('none');   
                     setParkingDisplay('none');                
                     setExcessIdleDisplay('none');
                     setLongStopDisplay('none');
                     setLateStartDisplay('none');
                     //setHighTemperatureDisplay('none');
                     //setLowTemperatureDisplay('none');
                     setExpiredDeviceDisplay('none');
                     setKilometerDisplay('none');                     
              }
            else if(Alert_TyprId == 12)//Leave Landmark Alert
            {
              setLandmarkDisplay('block');
              setMaintenanceStatusDisplay('none');
              setUnauthorizedUsageDisplay('none');
              setGeoFenceDisplay('none');
              setSpeedingDisplay('none');
              setIgnitionOnDisplay('none');
              setExcessIdleDisplay('none');
              setLongStopDisplay('none');
              setLateStartDisplay('none');
              setParkingDisplay('none');
              //setHighTemperatureDisplay('none');
              //setLowTemperatureDisplay('none');
              setExpiredDeviceDisplay('none');
              setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 19)//Parking Alert
            {
             
              setParkingDisplay('block');
              setMaintenanceStatusDisplay('none');
              setUnauthorizedUsageDisplay('none');
              setGeoFenceDisplay('none');
              setSpeedingDisplay('none');
              setIgnitionOnDisplay('none');
              setExcessIdleDisplay('none');
              setLongStopDisplay('none');
              setLateStartDisplay('none');             
              setExpiredDeviceDisplay('none');
              setLandmarkDisplay('none');
              setKilometerDisplay('none');
            }
            else if(Alert_TyprId == 26)//Kilometer Alert
            {
              setKilometerDisplay('block');
              setParkingDisplay('none');
              setMaintenanceStatusDisplay('none');
              setUnauthorizedUsageDisplay('none');
              setGeoFenceDisplay('none');
              setSpeedingDisplay('none');
              setIgnitionOnDisplay('none');
              setExcessIdleDisplay('none');
              setLongStopDisplay('none');
              setLateStartDisplay('none');             
              setExpiredDeviceDisplay('none');
              setLandmarkDisplay('none');              
            }
            else
            {
              setLandmarkDisplay('none');
              setMaintenanceStatusDisplay('none');
              setUnauthorizedUsageDisplay('none');
              setGeoFenceDisplay('none');
              setSpeedingDisplay('none');
              setIgnitionOnDisplay('none');
              setExcessIdleDisplay('none');
              setLongStopDisplay('none');
              setLateStartDisplay('none');
              setParkingDisplay('none');
              //setHighTemperatureDisplay('none');
              //setLowTemperatureDisplay('none');
              setExpiredDeviceDisplay('none');
              setKilometerDisplay('none');
            }
    
  }
const ChangeAlertId= (e) => {
         
         setAlertTypeId(e.target.value);
         ShowHideControls(e.target.value);
         inputs.thresholdValue=1;
}
const changekVHandler=(e)=> {

  setDistanceValue(e.target.value);
}
const changeVHandler = (event) => {

  if(event.target.name==='thresholdValue')
    {
          const re = /^[0-9\b]+$/;
          if (event.target.value === '' || re.test(event.target.value)) 
          {
           
                const name = event.target.name;
                const value = event.target.value;
                setInputs(values => ({...values, [name]: value}))
          }
          else
          {
            setInputs(values => ({...values, ['thresholdValue']: ""}))
                
          }          
    }
    else
    {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
    }
}

const changeEDHandler = (event) => {
  if(event.target.name==='kilometerHigh') 
  {
      setDistanceValue(event.target.value);
  }
 
  const name = event.target.name;
  const value = event.target.value;
  setInputsEdit(values => ({...values, [name]: value}))

  //inputsEdit.kilometerHigh
}
const SaveAlert = () => 
{         

if(vehicleNo =='0')
{
      toast.error("Please select vehicle.");
      return;
} 
else if(vehicleNo =='Select')
{
     toast.error("Please select vehicle.");
     return;
} 
else if(alertTypeId==0)
 {
      toast.error("Please select alert type.");
      return;
 }   

else if((alertTypeId==1 ||alertTypeId==13||alertTypeId==14||alertTypeId==15||alertTypeId==16||alertTypeId==17||alertTypeId==18)  && (inputs.maintenancedate==null || inputs.maintenancedate==''))
{
      toast.error("Please select date.");
      return;
}   
else if(alertTypeId==2 && (!inputs.timefrom))
{
        toast.error("Please select time from.");
        return;
}  
else if(alertTypeId==2 && (!inputs.timeto))
{
        toast.error("Please select time to.");
        return;
} 
else if(alertTypeId==2 && (inputs.timefrom > (inputs.timeto)))
{
        toast.error("Time from should be less than time to.");
        return;
} 
else if(alertTypeId==3 && (inputs.latitude==null))
{
        toast.error("Please enter latitude.");
        return;
}  
else if(alertTypeId==3 && (inputs.longitude==null))
{
        toast.error("Please enter longitude.");
        return;
}
else if(alertTypeId==3 && !(validationLatitudeLongitude.latitude(inputs.latitude)))
{
          toast.error("Please enter valid latitude.");
          return;
}  
else if(alertTypeId==3 && !(validationLatitudeLongitude.longitude(inputs.longitude)))
{
          toast.error("Please enter valid longitude.");
          return;
}
else if(alertTypeId==3 && (distanceValue==0))
{
        toast.error("Please enter radius.");
        return;
}    
else if(alertTypeId==4 && (inputs.maxspeed==null ||inputs.maxspeed<1))
{
        toast.error("Please enter max speed.");
        return;
}
else if(inputs.maxspeed>120)
{
          toast.error("Maximum speed limit is 120 km/h.");
          return;
}
else if(alertTypeId==5 && (inputs.latitude==null))
{
          toast.error("Please enter latitude.");
          return;
}  
else if(alertTypeId==5 && (inputs.longitude==null))
{
      toast.error("Please enter longitude.");
      return;
}
else if(alertTypeId==5 && !(validationLatitudeLongitude.latitude(inputs.latitude)))
{
       toast.error("Please enter valid latitude.");
       return;
}  
else if(alertTypeId==5 && !(validationLatitudeLongitude.longitude(inputs.longitude)))
{
       toast.error("Please enter valid longitude.");
       return;
}
else if(alertTypeId==5 && (distanceValue==0))
    {
        toast.error("Please enter radius.");
        return;
    }   
else if(alertTypeId==7 && (!inputs.excessIdle) || inputs.excessIdle<1)
   {
         toast.error("Please enter duration in minutes.");
         return;
   } 
 else if(alertTypeId==8 && (!inputs.longStop) || inputs.longStop<1)   
    {
         toast.error("Please enter duration in minutes.");
         return;
} 
else if(alertTypeId==9 && (!inputs.lateStart) || inputs.lateStart<1)
{
        toast.error("Please enter duration in minutes.");
        return;
} 
else if(alertTypeId==12 && (inputs.latitude==null))
{
        toast.error("Please enter latitude.");
        return;
}  
else if(alertTypeId==12 && !(validationLatitudeLongitude.latitude(inputs.latitude)))
{
        toast.error("Please enter valid latitude.");
        return;
}  
else if(alertTypeId==12 && !(validationLatitudeLongitude.longitude(inputs.longitude)))
{
        toast.error("Please enter valid longitude.");
        return;
}
else if(alertTypeId==12 && (distanceValue==0))
{
         toast.error("Please enter radius.");
         return;
} 
else if(alertTypeId==19 && (distanceValue==0))
{
          toast.error("Please enter radius.");
          return;
} 
else if(inputs.thresholdValue =='0' ||inputs.thresholdValue=='')
{
        toast.error("Please enter threshold value in minutes.");
        return;
}
else if(!inputs.thresholdValue) 
{
        toast.error("Please enter threshold value in minutes.");
        return;
}  
else if(inputs.thresholdValue<0)
{
        toast.error("Please enter valid threshold value in minutes.");
        return;
}   
else if(inputs.thresholdValue>60)
{
        toast.error("Please enter threshold value less than 60.");
        return;
}  
//kilometerHigh 
else if(alertTypeId == 26 &&  distanceValue==0)
{
        toast.error("Please enter distance in km.");
        return;
}  
/* Valid Latitude Format? */
//validationLatitudeLongitude.latitude(MY_LATITUDE);
/* Valid Longitude Format? */
//validationLatitudeLongitude.longitude(MY_LONGITUDE);       
else  
{     
    //Insert Device Details
     const params = JSON.stringify({
      "accountID": AccountID,
      "alertID": 0,
      "deviceID": dID,
      "vehicleNumber": vehicleNo,
      "alertTypeID": alertTypeId,
      "maintenancedate": inputs.maintenancedate==null?null:inputs.maintenancedate,
      "duration": (!inputs.thresholdValue)?0:inputs.thresholdValue,
      "maxTemprature": temperatureValue==""?0:temperatureValue,
      "minTempratute": temperatureValue==""?0:temperatureValue,
      "latitude": inputs.latitude==null?"0":inputs.latitude,
      "longitude": inputs.longitude==null?"0":inputs.longitude,
      "distance": distanceValue,
      "maxSpeed": inputs.maxspeed==null?"0":inputs.maxspeed,
      "lateStart": (!inputs.lateStart)?0:inputs.lateStart,
      "longStop": (!inputs.longStop)?0:inputs.longStop,
      "fromTime": (!inputs.timefrom)?'':inputs.timefrom,
      "toTime": (!inputs.timeto)?'':inputs.timeto,
      "excessIdle": (!inputs.excessIdle)?0:inputs.excessIdle,
      "ignitionStatus": ignitionType==""?'':ignitionType,
      "expiryDate":inputs.expirydate==null?null:inputs.expirydate,
      "CreatedBy": UserName,
      "Is_Enable": switchValue
  });
   
  axios.post(API_URL+'AlertSettingInsert/', params, 
  {
       "headers": 
       {
              "content-type": "application/json",    
       },
  })
    .then(function (response) 
    {
         if(!response.data.validStatus)
         {
                 toast.error(response.data.message);
                 return;
         }
         else
         {         
               toast.success(response.data.message);
               //console.log(response.data);
               setInputs({});          
         }                    
         
    }).catch(function (error) 
    {
            toast.error(error.message);
            console.log(error);    
    });
    /*comment*/     
  }
}
const UpdateAlert=()=>
{
              
        if(vehicleNo=='0')
        {
              toast.error("Please select vehicle.");
              return;
        } 
        else if(alertTypeId==0)
        {
              toast.error("Please select alert type.");
              return;
        }
        else if((alertTypeId==1 ||alertTypeId==13||alertTypeId==14||alertTypeId==15||alertTypeId==16||alertTypeId==17||alertTypeId==18) && (inputsEdit.maintenancedate==null || inputsEdit.maintenancedate==''))
         {
                toast.error("Please select date.");
                return;
         }   
          else if(alertTypeId==2 && (!inputsEdit.timefrom))
            {
                  toast.error("Please select time from.");
                  return;
            }  
          else if(alertTypeId==2 && (!inputsEdit.timeto))
              {
                  toast.error("Please select time to.");
                  return;
              } 
          else if(alertTypeId==2 && (inputsEdit.timefrom > inputsEdit.timeto))
            {
                  toast.error("Time from should be less than time to.");
                  return;
            } 
          else if(alertTypeId==3 && (inputsEdit.latitude==null))
            {
                  toast.error("Please enter latitude.");
                  return;
            }  
          else if(alertTypeId==3 && (inputsEdit.longitude==null))
            {
                  toast.error("Please enter longitude.");
                  return;
            }
            else if(alertTypeId==3 && !(validationLatitudeLongitude.latitude(inputsEdit.latitude)))
              {
                    toast.error("Please enter valid latitude.");
                    return;
              }  
          else if(alertTypeId==3 && !(validationLatitudeLongitude.longitude(inputsEdit.longitude)))
              {
                    toast.error("Please enter valid longitude.");
                    return;
              }
          else if(alertTypeId==3 && (distanceValue==0))
            {
                  toast.error("Please enter radius.");
                  return;
            }    
          else if(alertTypeId==4 && (inputsEdit.maxspeed==null || inputsEdit.maxspeed<1))
            {
                  toast.error("Please enter max speed.");
                  return;
            }
          else if(inputsEdit.maxspeed>120)
              {
                    toast.error("Maximum speed limit is 120 km/h.");
                    return;
              }
          else if(alertTypeId==5 && (inputsEdit.latitude==null))
              {
                    toast.error("Please enter latitude.");
                    return;
              }  
          else if(alertTypeId==5 && (inputsEdit.longitude==null))
              {
                    toast.error("Please enter longitude.");
                    return;
              }
              else if(alertTypeId==5 && !(validationLatitudeLongitude.latitude(inputsEdit.latitude)))
                {
                      toast.error("Please enter valid latitude.");
                      return;
                }  
            else if(alertTypeId==5 && !(validationLatitudeLongitude.longitude(inputsEdit.longitude)))
                {
                      toast.error("Please enter valid longitude.");
                      return;
                }
          else if(alertTypeId==5 && (distanceValue==0))
              {
                    toast.error("Please enter radius.");
                    return;
              }   
          else if(alertTypeId==7 && (!inputsEdit.excessIdle)||inputsEdit.excessIdle<1)
             {
                      toast.error("Please enter duration in minutes.");
                      return;
             } 
           else if(alertTypeId==8 && (!inputsEdit.longStop) ||inputsEdit.longStop<1)   
              {
                       toast.error("Please enter duration in minutes.");
                       return;
              } 
          else if(alertTypeId==9 && (!inputsEdit.lateStart)||inputsEdit.lateStart<1)
                {
                         toast.error("Please enter duration in minutes.");
                         return;
                } 
          else if(alertTypeId==12 && (inputsEdit.latitude==null))
                  {
                        toast.error("Please enter latitude");
                        return;
                  }  
          else if(alertTypeId==12 && (inputsEdit.longitude==null))
                  {
                        toast.error("Please enter longitude.");
                        return;
                  }
          else if(alertTypeId==12 && !(validationLatitudeLongitude.latitude(inputsEdit.latitude)))
          {
                          toast.error("Please enter valid latitude.");
                          return;
          }  
          else if(alertTypeId==12 && !(validationLatitudeLongitude.longitude(inputsEdit.longitude)))
          {
                  toast.error("Please enter valid longitude.");
                  return;
          }
          else if(alertTypeId==12 && (distanceValue==0))
          {
                   toast.error("Please enter radius.");
                   return;
          }  
          else if(alertTypeId==19 && (distanceValue==0))
          {
                    toast.error("Please enter radius.");
                    return;
          }   
          else if(inputsEdit.thresholdValue =='0' ||inputsEdit.thresholdValue=='')
          {
                    toast.error("Please enter threshold value in minutes.");
                    return;
          }
          else if(!inputsEdit.thresholdValue) 
          {
                    toast.error("Please enter threshold value in minutes.");
                    return;
          }  
          else if(inputsEdit.thresholdValue<0)
          {
                  toast.error("Please enter valid threshold value in minutes.");
                  return;
          }   
          else if(inputsEdit.thresholdValue>60)
          {
                toast.error("Please enter threshold value less than 60.");
                return;
          }    
          //kilometerHigh 
          else if(alertTypeId == 26 &&  distanceValue==0)
          {
              toast.error("Please enter distance in km.");
              return;
          }          
          else  
          {     //update Device Details
             const params = JSON.stringify({
        
              "accountID": AccountID,
              "alertID": alertId,
              "deviceID": dID,
              "vehicleNumber": vehicleNo,
              "alertTypeID": alertTypeId,
              "maintenancedate": inputsEdit.maintenancedate==null?null:inputsEdit.maintenancedate,
              "duration": (!inputsEdit.thresholdValue)?0:inputsEdit.thresholdValue,
              "maxTemprature": temperatureValue==""?0:temperatureValue,
              "minTempratute": temperatureValue==""?0:temperatureValue,
              "latitude": inputsEdit.latitude==null?"0":inputsEdit.latitude,
              "longitude": inputsEdit.longitude==null?"0":inputsEdit.longitude,
              "distance": distanceValue,
              "maxSpeed": inputsEdit.maxspeed==null?"0":inputsEdit.maxspeed,
              "lateStart": (!inputsEdit.lateStart)?0:inputsEdit.lateStart,
              "longStop": (!inputsEdit.longStop)?0:inputsEdit.longStop,
              "fromTime": (!inputsEdit.timefrom)?'':inputsEdit.timefrom,
              "toTime": (!inputsEdit.timeto)?'':inputsEdit.timeto,
              "excessIdle": (!inputsEdit.excessIdle)?0:inputsEdit.excessIdle,
              "ignitionStatus": ignitionType==""?'':ignitionType,
              "expiryDate":inputsEdit.expirydate==null?null:inputsEdit.expirydate,
              "CreatedBy": UserName,
              "Is_Enable": switchValue
          });
           
          axios.post(API_URL+'AlertSettingInsert/', params, 
          {
               "headers": 
               {
                      "content-type": "application/json",    
               },
          })
          .then(function (response) 
          {
                 if(!response.data.validStatus)
                 {
                         toast.error(response.data.message);
                         return;
                 }
                 else
                 {         
                       toast.success(response.data.message);
                       console.log(response.data);
                       setInputsEdit({});
                      
                 }                    
                 
            }).catch(function (error) 
            {
                    toast.error(error.message);
                    console.log(error);    
            });     
          }


}
const setIgnition_Type =(event) =>
{
     if(event.target.value==1)
     {
        setIgnitionType(1);               
     }
     else
     {
        setIgnitionType(2);         
     } 
     
}
const changeRangeHandler = (e) => 
{
    setTemperatureValue(e.target.value);
}
const changeRadiuseHandler=(e)=>
{
   setDistanceValue(e.target.value);
}
const handlePrint = useReactToPrint({
  documentTitle: "Alert Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});

const showSettingDetailsModal = (index) => {
       
        setShowAlertSettingDetails(true);
        
        const vurls=API_URL+`AlertSettingByID/?AlertID=${index}`;
        //alert(vurls);
        axios.post(vurls).then(response => {                 
             setVehicleNo(response.data.data[0].vehicleNumber);
             setAlertTypeId(response.data.data[0].alertTypeID);
             setAlertType(response.data.data[0].alertType);
                         
             if(response.data.data[0].alertTypeID==12)  //Leave Landmark
              {
                setLatitude(response.data.data[0].latitude);
                setLongitude(response.data.data[0].longitude);
                setDistanceValue(response.data.data[0].distance);   
              }
              else if(response.data.data[0].alertTypeID==11) // Ignition OFF
              {
                    setIgnitionStatus(response.data.data[0].ignitionStatus);
              }
              else if(response.data.data[0].alertTypeID==10)
              {
                     setExpiryDate(response.data.data[0].expiryDate);
              }
              else if(response.data.data[0].alertTypeID==9)
              {
                      setDuration(response.data.data[0].lateStart);              
              }  
              else if(response.data.data[0].alertTypeID==8)
              {
                      setDuration(response.data.data[0].longStop);
              }
              else if(response.data.data[0].alertTypeID==7)
              {
                      setDuration(response.data.data[0].excessIdle);
              }
              else if(response.data.data[0].alertTypeID==6)   //ignitionStatus
              {
                      setIgnitionStatus(response.data.data[0].ignitionStatus);
              }
              else if(response.data.data[0].alertTypeID==5) //Landmark Alert
              {        
                      setLatitude(response.data.data[0].latitude);
                      setLongitude(response.data.data[0].longitude);
                      setDistanceValue(response.data.data[0].distance);                       
              }
              else if(response.data.data[0].alertTypeID==4) //Speeding Alert
              {
                      setMaxmSpeed(response.data.data[0].maxSpeed);
              }
              else if(response.data.data[0].alertTypeID==3) //Geo-fence Alert
              {
                      setLatitude(response.data.data[0].latitude);
                      setLongitude(response.data.data[0].longitude);
                      setDistanceValue(response.data.data[0].distance); 
              }
              else if(response.data.data[0].alertTypeID==2)   //Unauthorized Usage Alert
              {
                      setTimeFrom(response.data.data[0].fromTime);
                      setTimeTo(response.data.data[0].toTime);
              }
              else if(response.data.data[0].alertTypeID==1 ||response.data.data[0].alertTypeID==13||response.data.data[0].alertTypeID==14||response.data.data[0].alertTypeID==15||response.data.data[0].alertTypeID==16||response.data.data[0].alertTypeID==17||response.data.data[0].alertTypeID==18)   //Maintenance Status Alert
              {
                      setMaintenanceDate(response.data.data[0].maintenanceDate);
              }
              else if(response.data.data[0].alertTypeID==19) //Parking Alert
              {
                      setLatitude(response.data.data[0].latitude);
                      setLongitude(response.data.data[0].longitude);
                      setDistanceValue(response.data.data[0].distance); 
              }
               else if(response.data.data[0].alertTypeID==26) //Geo-fence Alert
              {
                      setDistanceValue(response.data.data[0].distance); 
                      setKilometerDisplay("block");
              }
              else
              {
                    setExpiryDate("");
                    setTemperatureValue(0); 
                    setDuration(0);
                    setMaintenanceDate("");
              }
                
                  ShowHideControls(response.data.data[0].alertTypeID);
          
         }).catch(function(error) 
         {
           console.log(error.message);
         });     
}
const showEditSettingDetails = (index) => {
        //alert(index);
        setAlertId(index);
        setKilometerDisplay("none"); 
        setShowEditAlertSettingDetails(true);
        setDistanceValue(0);
        // const eurls=API_URL+`VehicleList/?AccountID=${AccountID}&TypeID=0`;  
        const eurls=API_URL+`AlertSettingByID/?AlertID=${index}`;
        
        axios.get(eurls).then(response =>
        {                  
               const updated_List =  response.data.data.filter((curElem) => {
               return curElem.status === "Enabled";
        });   
               setVehicleData(updated_List); 
        }).catch(function(error) 
        {  
               console.log(error.message); 
        });

            //setAlertData
            const Alurle = API_URL+`GetAlertTypes/?AccountID=0`;    //Zero meanse all alert list       
            setAlertData([]); 
            axios.post(Alurle).then(response => 
            {  
                  
                setAlertData(response.data.data)   
           
            }).catch(function(error) { console.log(error.message);  });
            const vurls=API_URL+`AlertSettingByID/?AlertID=${index}`;
            
             axios.post(vurls).then(response => {    
             //console.log("----------------------Alert Setting response.data.data---------------------------------");
             //console.log(response.data.data);
             setVehicleNo(response.data.data[0].vehicleNumber);
             setAlertTypeId(response.data.data[0].alertTypeID);
             setAlertType(response.data.data[0].alertType);
             setDID(response.data.data[0].deviceID);
             setSwitchValue(response.data.data[0].is_Enable); 
             
             inputsEdit.thresholdValue=  response.data.data[0].duration;
             if(response.data.data[0].alertTypeID==12)  //Leave Landmark  
              {
                    inputsEdit.latitude=response.data.data[0].latitude;
                    inputsEdit.longitude = response.data.data[0].longitude;
                    setDistanceValue(response.data.data[0].distance);                   
              }
              else if(response.data.data[0].alertTypeID==11)   //Ignition OFF Alert
              {
                    if(response.data.data[0].ignitionStatus=="ON")
                    {
                          setIgnitionType(1);
                    }
                    else
                    {
                          setIgnitionType(2);
                    }    
              }
              else if(response.data.data[0].alertTypeID==10)   //Expired Device
              {
                   inputsEdit.expirydate=response.data.data[0].expiryDate;
              }
              else if(response.data.data[0].alertTypeID==9)  //Late Start Alert
              {
                  inputsEdit.lateStart  = response.data.data[0].lateStart;              
              }  
              else if(response.data.data[0].alertTypeID==8)   //Long Stop Alert
              {
                  inputsEdit.longStop = response.data.data[0].longStop;
              }
              else if(response.data.data[0].alertTypeID==7)   //Excess Idle 
              {
                  inputsEdit.excessIdle = response.data.data[0].excessIdle;
              }
              else if(response.data.data[0].alertTypeID==6)   //ignitionStatus
              {
                      //alert(response.data.data[0].ignitionStatus);
                      if(response.data.data[0].ignitionStatus=="ON")
                        {
                           setIgnitionType(1);
                        }
                        else
                        {
                          setIgnitionType(2);
                        }                      
              }
              else if(response.data.data[0].alertTypeID==5) //Landmark Alert
              {        
                      inputsEdit.latitude=response.data.data[0].latitude;
                      inputsEdit.longitude = response.data.data[0].longitude;
                      setDistanceValue(response.data.data[0].distance);                       
              }
              else if(response.data.data[0].alertTypeID==4) //Speeding Alert
              {
                      inputsEdit.maxspeed = response.data.data[0].maxSpeed;
              }
              else if(response.data.data[0].alertTypeID==3) //Geo-fence Alert
              {
                      inputsEdit.latitude = response.data.data[0].latitude;
                      inputsEdit.longitude = response.data.data[0].longitude;
                      setDistanceValue(response.data.data[0].distance); 
              }
              else if(response.data.data[0].alertTypeID==19) //Parking Alert
              {        
                      //inputsEdit.latitude=response.data.data[0].latitude;
                      //inputsEdit.longitude = response.data.data[0].longitude;
                      setDistanceValue(response.data.data[0].distance);                       
              }
              else if(response.data.data[0].alertTypeID==2)   //Unauthorized Usage Alert
              {
                      inputsEdit.timefrom = response.data.data[0].fromTime;
                      inputsEdit.timeto = response.data.data[0].toTime;
              }
              else if(response.data.data[0].alertTypeID==1||response.data.data[0].alertTypeID==13||response.data.data[0].alertTypeID==14||response.data.data[0].alertTypeID==15||response.data.data[0].alertTypeID==16||response.data.data[0].alertTypeID==17||response.data.data[0].alertTypeID==18)   //Maintenance Status Alert
              {
                     inputsEdit.maintenancedate= response.data.data[0].maintenanceDate;
              }
              else if(response.data.data[0].alertTypeID==26)  //kilometer high alert 
              {
                    inputsEdit.kilometerHigh=response.data.data[0].distance;
                    setDistanceValue(response.data.data[0].distance);   
                    setKilometerDisplay("block");                
              }
              else
              {
                    setExpiryDate("");
                    setTemperatureValue(0); 
                    setDuration(0);
                    setMaintenanceDate("");
              }
                ShowHideControls(response.data.data[0].alertTypeID);

                }).catch(function(error) 
                {
                  console.log(error.message);
                }); 
}

const handleSwitchChange=(switchValue)=>
{
      setSwitchValue(switchValue);       
}

return ( <>  
       {/*Alert Settings Popup*/}          
              <Modal isOpen={showDetails} >  
              <div  class="modal-header">
              <h5 className='modal-title'>Alert Settings </h5>
              <button type="button" class="btn-close" onClick={closeModal}></button>
              </div>
              <div class="modal-body"> 
              <div class="row">
              <div class="col-sm-6 col-md-4 form-group">&nbsp;
              Vehicle : <span style={{color:"red"}}>&nbsp;*</span>        
              <select className="form-control"  name="DVehicleNo" value={dID} onChange={ChangeVehicleNo} >
              <option value={0}>Select</option>
              {vehicleData.map((e, key) => {
                return <option key={key} value={e.deviceID}>{e.vehicleNumber}</option>;
              })}
              </select> 
		          </div>  
              <div class="col-sm-6 col-md-4 form-group">&nbsp;
              Alert Type : <span style={{color:"red"}}>&nbsp;*</span>        
              <select className="form-control"  name="DAlertType" value={alertTypeId} onChange={ChangeAlertId} >
              <option value={0}>Select</option>
              {alertData.map((e, key) => {
              return <option key={key} value={e.alertTypeID}>{e.alertType}</option>;
              })}
              </select> 
		          </div>  
              <div class="col-sm-6 col-md-4 form-group" style={{display: maintenanceStatusDisplay }}>&nbsp;
              Date : 
              <input type="date" className="form-control" name="maintenancedate" value={inputs.maintenancedate} min={today}   onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: unauthorizedUsageDisplay }}>&nbsp;
              Time From : <br/>
              <input type="time" className="form-control" name="timefrom" value={inputs.timefrom}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: unauthorizedUsageDisplay }}>&nbsp;
              Time To : <br/>
              <input type="time" className="form-control" name="timeto" value={inputs.timeto}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              Geofence Latitude : <br/>
              <input type="text" className="form-control"  name="latitude" value={inputs.latitude}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              Geofence Longitude : <br/>
              <input type="text" className="form-control"  name="longitude" value={inputs.longitude}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              Radius (Meters) : <span>{distanceValue}</span>
              <input id="alertRange" type="range" class="form-range" name="distance" min="0" max="100"  value={distanceValue} onChange={changeRadiuseHandler} />
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: speedingDisplay }}>&nbsp;
              Maximum Speed : (Km/hour) <br/>
              <input type="text" className="form-control" maxLength={10} name="maxspeed" value={inputs.maxspeed}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
              Latitude : <br/>
              <input type="text" className="form-control" maxLength={10} name="latitude" value={inputs.latitude}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
              Longitude : <br/>
              <input type="text" className="form-control" maxLength={10} name="longitude" value={inputs.longitude}  onChange={changeVHandler}/> 
            </div>
            <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
            Radius (Meters) : <span>{distanceValue}</span>
            <input id="alertRange" type="range" class="form-range" min="0" max="100" name="distance"  value={distanceValue} onChange={changeRadiuseHandler} />
            </div> 
            <div class="col-sm-6 col-md-4 form-group" style={{display: parkingDisplay }}>&nbsp;
            Radius (Meters) : <span>{distanceValue}</span>
            <input id="alertRange" type="range" class="form-range" min="0" max="100" name="distance"  value={distanceValue} onChange={changeRadiuseHandler} />
            </div> 
            {/*<div class="col-sm-6 col-md-4 form-group" onChange={setIgnition_Type.bind(ignitionType)} style={{ "padding-top": "27px" ,"fontSize":"16px",display: ignitionOnDisplay }}>&nbsp;
            <input type="radio"  value="1" name="ignitionAlert" checked={ignitionType === 1?true:false}/> ON 
            &nbsp;&nbsp;<input type="radio" value="2" name="ignitionAlert" checked={ignitionType === 2?true:false}/> OFF
            </div>*/}
            <div class="col-sm-6 col-md-4 form-group" style={{display: excessIdleDisplay }}>&nbsp;
            Minutes : <br/>
            <input type="text" className="form-control" maxLength={3} name="excessIdle" value={inputs.excessIdle}  onChange={changeVHandler}/>
            </div> 
            <div class="col-sm-6 col-md-4 form-group" style={{display: longStopDisplay }}>&nbsp;
            Minutes : <br/>
            <input type="text" className="form-control" maxLength={3} name="longStop" value={inputs.longStop}  onChange={changeVHandler}/>
            </div> 
            <div class="col-sm-6 col-md-4 form-group" style={{display: lateStartDisplay }}>&nbsp;
            Minutes : <br/>
            <input type="text" className="form-control" maxLength={3} name="lateStart" value={inputs.lateStart}  onChange={changeVHandler}/>
            </div> 
            <div class="col-sm-6 col-md-4 form-group" style={{display: kilometerDisplay }}>&nbsp;
            Distance (in Kms.) : 
            <input type="text" className="form-control" maxLength={5} name="kilometerHigh" value={inputs.kilometerHigh}  onChange={changekVHandler}/>
            </div> 
             {/* 
             <div class="col-sm-6 col-md-4 form-group" style={{display: highTemperatureDisplay }}>&nbsp;
              High Temperature : <span>{temperatureValue}</span>
              <input id="alertRange" type="range" class="form-range" min="0" max="100" name="temperatureValue2"  value={temperatureValue} onChange={changeRangeHandler} />
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: lowTemperatureDisplay }}>&nbsp;
              Low Temperature : <span>{temperatureValue}</span>
              <input id="alertRange" type="range" class="form-range" min="0" max="100" name="temperatureValue3"  value={temperatureValue} onChange={changeRangeHandler} />
              </div> 
              */}
              <div class="col-sm-6 col-md-4 form-group" style={{display: expiredDeviceDisplay }}>&nbsp;
              Expiry Date :               
              <input type="text" className="form-control" disabled={true} name="expirydate" value={inputs.expirydate}   onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{ display: thresholdValueDisplay}} >&nbsp;
              Threshold Value (Minutes) : <br/>
              <input type="text" className="form-control"   maxLength={2} name="thresholdValue" value={inputs.thresholdValue} style={{ width: "40%", padding: "6px 6px !important" }}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-12 col-md-12 form-group">&nbsp;
              <center>
              <button className="btn btn-primary2" onClick={() => SaveAlert()}>Save</button> 
              </center></div> 
              </div>  
              </div>
                   
</Modal>            
{/*ENd Alert Settings Popup*/}       

<Modal isOpen={showAlertSettingDetails} >  
              <div  class="modal-header">
              <h5 className='modal-title'>Alert Settings Details</h5>
              <button type="button" class="btn-close" onClick={closeModal}></button>
              </div>
              <div class="modal-body"> 
              <div class="row">
              <div class="col-sm-6 col-md-4 form-group">&nbsp;
              <b>Vehicle# :</b><br/>
             <span> {vehicleNo} </span>
		          </div>  
              <div class="col-sm-6 col-md-4 form-group">&nbsp;
              <b>Alert Type :</b> <br/>          
              <span> {alertType} </span>
		          </div>  
              <div class="col-sm-6 col-md-4 form-group" style={{display: maintenanceStatusDisplay }}>&nbsp;
              <b>Date :</b> 
              <br/>          
              <span> {maintenanceDate} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{ display: ignitionOnDisplay }}>&nbsp;
              <b>Ignition Staus:</b> <br/>
              <span> {ignitionStatus} </span>
              </div>
              <div class="col-sm-6 col-md-4 form-group" style={{display: unauthorizedUsageDisplay }}>&nbsp;
              <b>Time From :</b> 
              <br/>          
              <span> {timeFrom} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: unauthorizedUsageDisplay }}>&nbsp;
              <b>Time To :</b> <br/>          
              <span> {timeTo} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              <b>Geofence Latitude :</b> <br/>          
              <span> {latitude} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              <b>Geofence Longitude :</b> <br/>          
              <span> {longitude} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              <b>Radius(Meters) :</b> <br/>          
              <span> {distanceValue} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: speedingDisplay }}>&nbsp;
              <b>Maximum Speed :(in Km/hour)</b> <br/>
              <span> {maxmSpeed} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
              <b>Latitude :</b> <br/>
              <span> {latitude} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
              <b>Longitude :</b> <br/>
              <span> {longitude} </span>
              </div>
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
              <b>Radius(Meters) :</b><br/> <span>{distanceValue}</span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: parkingDisplay }}>&nbsp;
              <b>Latitude :</b> <br/>
              <span> {latitude} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: parkingDisplay }}>&nbsp;
              <b>Longitude :</b> <br/>
              <span> {longitude} </span>
              </div>
               <div class="col-sm-6 col-md-4 form-group" style={{display: kilometerDisplay }}>&nbsp;
              <b>Distance (Kilometers) :</b><br/> <span>{distanceValue}</span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: parkingDisplay }}>&nbsp;
              <b>Radius(Meters) :</b><br/> <span>{distanceValue}</span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: excessIdleDisplay }}>&nbsp;
              <b>Minutes :</b> <br/>
              <span> {duration} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: longStopDisplay }}>&nbsp;
              <b>Minutes :</b> <br/>
              <span> {duration} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: lateStartDisplay }}>&nbsp;
              <b>Minutes : </b><br/>
              <span> {duration} </span>
              </div> 
              {/*<div class="col-sm-6 col-md-4 form-group" style={{display: highTemperatureDisplay }}>&nbsp;
              <b>High Temperature :</b> <br/>
              <span>{temperatureValue}</span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: lowTemperatureDisplay }}>&nbsp;
              <b>Low Temperature :</b>
              <br/>
              <span>{temperatureValue}</span>
              </div> */}
              <div class="col-sm-6 col-md-4 form-group" style={{display: expiredDeviceDisplay }}>&nbsp;
              <b>Expiry Date : </b>  <br/>             
              <span> {expiryDate} </span>              
              </div> 
              <div class="col-sm-12 col-md-12 form-group">&nbsp; </div> 
              </div>                        
              </div>
                   
</Modal>  
<Modal isOpen={showEditAlertSettingDetails} >  
              <div  class="modal-header">
              <h5 className='modal-title'>Edit Alert Settings</h5>
              <button type="button" class="btn-close" onClick={closeModal}></button>
              </div>
              <div class="modal-body"> 
              <div class="row">
              <div class="col-sm-6 col-md-4 form-group">
              Vehicle# :<br/>
             <span> {vehicleNo} </span>
		          </div>  
              <div class="col-sm-6 col-md-4 form-group">
              Alert Type : <br/>          
              <span> {alertType} </span>
		          </div>  
              <div class="col-sm-6 col-md-4 form-group" style={{display: maintenanceStatusDisplay }}>
              Date : 
              <input type="date" className="form-control" name="maintenancedate" value={inputsEdit.maintenancedate} min={today}  onChange={changeEDHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: unauthorizedUsageDisplay }}>
              Time From : <br/>
              <input type="time" className="form-control" name="timefrom" value={inputsEdit.timefrom}  onChange={changeEDHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: unauthorizedUsageDisplay }}>
              Time To : <br/>
              <input type="time" className="form-control" name="timeto" value={inputsEdit.timeto}  onChange={changeEDHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>
              Geofence Latitude : <br/>
              <input type="text" className="form-control"  name="latitude" value={inputsEdit.latitude}  onChange={changeEDHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>
              Geofence Longitude : <br/>
              <input type="text" className="form-control"  name="longitude" value={inputsEdit.longitude}  onChange={changeEDHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>
              Radius (Meters) : <span>{distanceValue}</span>
              <input id="alertRange" type="range" class="form-range" name="distance" min="0" max="100"  value={distanceValue} onChange={changeRadiuseHandler} />
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: speedingDisplay }}>
              Maximum Speed :(in Km/hour) <br/>
              <input type="text" className="form-control" maxLength={3} name="maxspeed" value={inputsEdit.maxspeed}   onChange={changeEDHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>
              Latitude : <br/>
              <input type="text" className="form-control" maxLength={10} name="latitude" value={inputsEdit.latitude}  onChange={changeEDHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>
              Longitude : <br/>
              <input type="text" className="form-control" maxLength={10} name="longitude" value={inputsEdit.longitude}  onChange={changeEDHandler}/> 
            </div>
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>
              Radius (Meters) : <span>{distanceValue}</span>
              <input id="alertRange" type="range" class="form-range" min="0" max="100" name="distance"  value={distanceValue} onChange={changeRadiuseHandler} />
              </div> 
             
              <div class="col-sm-6 col-md-4 form-group" style={{display: parkingDisplay }}>&nbsp;
              Radius (Meters) : <span>{distanceValue}</span>
              <input id="alertRange" type="range" class="form-range" min="0" max="100" name="distance"  value={distanceValue} onChange={changeRadiuseHandler} />
              </div> 
              {/*<div class="col-sm-6 col-md-4 form-group" onChange={setIgnition_Type.bind(ignitionType)} style={{ "padding-top": "27px" ,"fontSize":"16px",display: ignitionOnDisplay }}>&nbsp;
              <input type="radio"  value="1" name="ignitionAlert" checked={ignitionType === 1?true:false}/> ON 
              &nbsp;&nbsp;<input type="radio" value="2" name="ignitionAlert" checked={ignitionType === 2?true:false}/> OFF
              </div>*/}
              <div class="col-sm-6 col-md-4 form-group" style={{display: excessIdleDisplay }}>
              Minutes : <br/>
              <input type="text" className="form-control" maxLength={3} name="excessIdle" value={inputsEdit.excessIdle}  onChange={changeEDHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: longStopDisplay }}>
              Minutes : <br/>
              <input type="text" className="form-control" maxLength={3} name="longStop" value={inputsEdit.longStop}  onChange={changeEDHandler}/>
              </div> 
             <div class="col-sm-6 col-md-4 form-group" style={{display: lateStartDisplay }}>
             Minutes : <br/>
             <input type="text" className="form-control" maxLength={3} name="lateStart" value={inputsEdit.lateStart}  onChange={changeEDHandler}/>
             </div> 
            {/* <div class="col-sm-6 col-md-4 form-group" style={{display: highTemperatureDisplay }}>
             High Temperature : <span>{temperatureValue}</span>
             <input id="alertRange" type="range" class="form-range" min="0" max="100" name="temperatureValue2"  value={temperatureValue} onChange={changeRangeHandler} />
             </div> 
             <div class="col-sm-6 col-md-4 form-group" style={{display: lowTemperatureDisplay }}>
             Low Temperature : <span>{temperatureValue}</span>
             <input id="alertRange" type="range" class="form-range" min="0" max="100" name="temperatureValue3"  value={temperatureValue} onChange={changeRangeHandler} />
             </div> */}
             <div class="col-sm-6 col-md-4 form-group" style={{display: expiredDeviceDisplay }}>
             Expiry Date :               
             <input type="date" className="form-control" name="expirydate" value={inputsEdit.expirydate} disabled={true} onChange={changeEDHandler}/>
             </div> 
             <div class="col-sm-6 col-md-4 form-group" style={{display: kilometerDisplay }}>&nbsp;
             Distance (in Kms.) : 
             <input type="text" className="form-control" maxLength={5} name="kilometerHigh" value={inputsEdit.kilometerHigh}  onChange={changeEDHandler}/>
             </div> 
             <div class="col-sm-6 col-md-4 form-group">&nbsp;
             Enable : <br/>
             <Switch onChange={handleSwitchChange} checked={switchValue} />
             </div>
             <div class="col-sm-6 col-md-4 form-group" >&nbsp;
              Threshold Value (Minutes) : <br/>
              <input type="text" className="form-control" maxLength={2} name="thresholdValue" value={inputsEdit.thresholdValue} style={{ width: "40%", padding: "6px 6px !important" }}  onChange={changeEDHandler}/>
              </div> 
             <div class="col-sm-12 col-md-12 form-group">
             <center>
             <button className="btn btn-primary2" onClick={() => UpdateAlert()}>Update</button> 
             </center>
             </div> 
             </div>                        
             </div>
                   
</Modal>            

 
      <div className="top-bar clearfix">
      <div className="row">       
       <div className="col-md-4">
       <h2> Alert Settings  </h2>           
         </div>
         <div className="col-md-8 text-right">


         <button type="submit" id="Save" onClick={() =>NewAlertSettingModal()} className="btn btn-new"> Settings </button>
            
            <select onChange={exportStatus} className="btn btn-primary" name="DStatus" value={statusId} >               
            <option value={"0"}>All</option>
            <option value={"1"}>Enabled</option>
            <option value={"2"}>Disabled</option>                    
            </select> 

            <select onChange={exportDownload}  className="btn btn-primary" name="DDownload">
            <option value={"Download"}>Download</option>    
            <option value={"Excel"}>Excel</option>    
            <option value={"PDF"}>PDF</option>                     
            </select>
         </div>

       </div>

      </div>
    
    <div className="container-fluid p-3">

  {/* Filter data start */}
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">
  
      <div class="col-sm-3 col-lg-2">Vehicle#<input type="text" class="form-control" tabindex="1" id="txtTripNumber" value={SNo} onChange={changeHandler} maxlength="50"/>
      </div>
     
      <div class="col-sm-3 col-lg-2">Priority
      <select className="form-control"  name="startAddress" value={advPriority} onChange={ChangeSourceAddress} >
                            <option>Select Priority Type</option>
                            {arrayPriority.map((e, key) => 
                            {
                            return <option key={key} value={e.priorities}>{e.priorities}</option>;
                            })}
                            </select>
     </div>

      <div class="col-sm-3 col-lg-2">Alert Type
      <select className="form-control"  name="endAddress" value={advAlertType} onChange={ChangeEndAddress} >
                            <option>Select Alert Type</option>
                            {arrayAlertType.map((e, key) => {
                            return <option key={key} value={e.alertType}>{e.alertType}</option>;
                            })}
                            </select>     
      </div>
      <div class="col-sm-4 col-lg-2">
      <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnTripAdvancedSearchNew" onClick={FilterGrid} >Search</button>
      <button type="button" class="btn btn-secondary mt-20" id="btnTripResetAdvancedSearchNew" tabindex="7" onClick={ResetTripList}>Reset
      </button></div>
      </div>
    
  </div></div>
  {/* Filter data end  */}



  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body p-0">
          <table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
          <thead>
            <tr>
                <th width="5%"  style={{textAlign:"center","cursor": "pointer"}}>S.No. </th>
                <th width="10%" onClick={()=>sorting("vehicleNumber") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Number  &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="7%" onClick={()=>sorting("priorities") } style={{textAlign:"center","cursor": "pointer"}}>Priorities &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="15%" onClick={()=>sorting("alertType") } style={{textAlign:"center","cursor": "pointer"}}>Alert Type  &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                 <th width="35%" onClick={()=>sorting("smsContent") } style={{textAlign:"center","cursor": "pointer"}}>Description &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="5%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("CreatedBy") } style={{textAlign:"center","cursor": "pointer"}}>Created By &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="13%" onClick={()=>sorting("CreatedON") } style={{textAlign:"center","cursor": "pointer"}}>Created ON &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th style={{textAlign:"center"}} width="8%">Action</th>
            </tr>
         </thead>
        <tbody>
        {currentPost.map((devdata) => {
        return (
            <>
            <tr key={devdata.id}>
              <td style={{textAlign:"center"}}>{devdata.alertID}</td>
              <td>{devdata.vehicleNumber}</td>
              <td  class={devdata.priorities==="Critical"?"text-danger":(devdata.priorities==="Low"?"text-success":"text-warning")}><b>{devdata.priorities}</b></td>
              <td>{devdata.alertType}</td>
              <td style={{textAlign: "left"}}>{devdata.smsContent}</td>
              <td style={{textAlign:"center"}}>{devdata.status}</td>
              <td style={{textAlign:"center"}}>{devdata.createdBy}</td>
              <td style={{textAlign:"center"}}>{devdata.createdON}</td>      
              <td style={{textAlign:"center", fontSize:"14px"}}>
              <i onClick={() => showSettingDetailsModal(devdata.id)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
              &nbsp;&nbsp; <i onClick={() => showEditSettingDetails(devdata.id)} style={{ color:"rgb(13, 110, 253)", cursor:'pointer'}} className="fa-solid fa-pen-to-square" title="Update Details"></i>
              </td>                
            </tr>
            </>
              );
              })}
            </tbody>
          </table>
          <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount} onPageChange={ChangePage}     
          disableInitialCallback={true}  initialPage={0}  containerClassName={'pagination justify-content-end'}
          pageClassName={'page-item'}  pageLinkClassName={'page-link'}  previousClassName={'page-item'}  previousLinkClassName={'page-link'}
          nextClassName={'page-item'}  nextLinkClassName={'page-link'} breakClassName={'page-item'}  breakLinkClassName={'page-link'}  activeClassName={'active'}></ReactPaginate>
          </div> </div>  </div>
          <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>  
            
        </>
    );
  }

export default AlertSettings;
